import styled from 'styled-components';

export const FixSelectStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
